import React, { Fragment } from 'react';
import PasswordStrengthBarItem from './PasswordStrengthBarItem';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const rootStyle = {
  position: 'absolute',
  zIndex: '100',
  borderRadius: '5px',
  width: '100%',
  display: 'flex',
  flexFlow: 'column'
};

const containerStyle = {
  background: '#f6f6f6',
  boxShadow: '2px 3px 3px 0px #ccc',
  padding: '15px 20px 10px',
  border: '1px solid #dbdbdb',
  borderRadius: '5px',
  width: '300px',
  maxWidth: '300px',
  margin: '0px auto'
};

const wrapStyle = {
  display: 'flex',
  alignItems: 'center',
  margin: '5px 0 0',
};

const spaceStyle = {
  width: 6,
};

const descStyle = {
  color: '#898792',
  fontSize: '14px',
  marginTop: '2px'
};

const checkStyle = {
  fontSize: '16px',
  marginTop: '-2px'
}

const triangleStyle = {
  width: 0,
  height: 0,
  borderLeft: '15px solid transparent',
  borderRight: '15px solid transparent',
  borderBottom: '15px solid #dbdbdb',
  margin: 'auto'
}

const triangleStyle2 = {
  width: 0,
  height: 0,
  borderLeft: '15px solid transparent',
  borderRight: '15px solid transparent',
  borderBottom: '16px solid #f6f6f6',
  marginLeft: '-15px',
  marginTop: '1px',
  position: 'absolute',
  zIndex: 100,
  boxShadow: '0px 0px 0px 0px #f6f6f6'
}

const required_message = "Required: 12 characters with 1 uppercase, 1 lowercase, 1 number \t\t and 1 symbol";

class PasswordStrengthBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      score: 0,
      minCharacters: false,
      upperOrLowercase: false,
      oneNumber: false,
      oneSymbol: false
    };
  }

  static defaultProps = {
    className: undefined,
    style: undefined,
    scoreWordClassName: undefined,
    scoreWordStyle: undefined,
    password: '',
    userInputs: [],
    barColors: ['#ddd', '#f83333', '#f6b44d', '#2b90ef', '#25c281'],
    scoreWords: ['too short', 'too short', required_message,
      required_message, 'strong'],
    minLength: 4,
    shortScoreWord: 'too short',
    onChangeScore: undefined,
  };

  componentDidMount() {
    this.setScore();
  }

  componentDidUpdate(prevProps) {
    const { password } = this.props;
    if (prevProps.password !== password) {
      this.setScore();
    }
  }

  setScore = () => {
    const { password, minLength, onChangeScore } = this.props;
    let score = 0;
    let feedback = {};
    let minCharacters = false;
    let upperOrLowercase = false;
    let oneNumber = false;
    let oneSymbol = false;
    if (password.length >= minLength) {
      minCharacters = true;
      score++;
    }

    if (password.match("^(?=.*[a-z])(?=.*[A-Z]).+$")) {
      upperOrLowercase = true;
      score++;
    }

    if (password.match("^(?=.*\\d).+$")) {
      oneNumber = true;
      score++;
    }

    if (password.match("^(?=.*[-+_!@#$%^&*.,?]).+$")) {
      oneSymbol = true;
      score++;
    }



    this.setState(
      {
        score,
        minCharacters,
        upperOrLowercase,
        oneNumber,
        oneSymbol,
      },
      () => {
        if (onChangeScore) {
          onChangeScore(score, feedback);
        }
      },
    );
  };

  render() {
    const {
      className,
      style,
      barColors,
      minLength
    } = this.props;
    const { score, minCharacters, upperOrLowercase, oneNumber, oneSymbol } = this.state;

    return (
      <div className={className} style={{ ...rootStyle, ...style }}>
        <div style={{ ...triangleStyle }}>
          <div style={{ ...triangleStyle2 }}></div>
        </div>
        <div style={{ ...containerStyle }}>

          <div style={{ textAlign: "left", fontSize: '14px' }}>
            Your password must have:
            <div style={{ ...descStyle, color: minCharacters ? "green" : "#898792" }}><CheckCircleOutlineIcon style={checkStyle} /> {minLength} or more characters</div>
            <div style={{ ...descStyle, color: upperOrLowercase ? "green" : "#898792" }}><CheckCircleOutlineIcon style={checkStyle} /> Upper & lowercase letters</div>
            <div style={{ ...descStyle, color: oneNumber ? "green" : "#898792" }}><CheckCircleOutlineIcon style={checkStyle} /> At least one number</div>
            <div style={{ ...descStyle, color: oneSymbol ? "green" : "#898792" }}><CheckCircleOutlineIcon style={checkStyle} /> At least one symbol</div>
          </div>

          <div style={{ textAlign: "left", fontSize: '14px', marginTop: "16px" }}>Strength:</div>
          <div style={wrapStyle}>
            {[1, 2, 3, 4].map((el) => (
              <Fragment key={`password-strength-bar-item-${el}`}>
                {el > 1 && <div style={spaceStyle} />}
                <PasswordStrengthBarItem score={score} itemNum={el} barColors={barColors} />
              </Fragment>
            ))}
          </div>
          <div style={{ textAlign: "left", fontSize: '14px', marginTop: "10px" }}>Avoid using a password that you use with other websites or that might be easy for someone else to guess.</div>
        </div>
      </div>
    );
  }
}

export default PasswordStrengthBar;
